module.exports.config = {
  "declarative": true,
  "render-module": {
    "name": "PieceSeparatorRenderModule",
    "path": "front/piece-separator-render.module"
  },
  "definition": {
    "type": "horizontal-rule",
    "name": "PieceSeparatorDefinition",
    "group": "Basic",
    "availablePlatforms": ["web", "apps"],
    "description": "Separador Horizontal",
    "fields": [
      {
        "name": "height",
        "label": "Alto",
        "type": "units",
        "mandatory": false,
        "defaultValue": "1pt",
        "jsonPath": "styles.height"
      },
      {
        "name": "width",
        "label": "Ancho",
        "type": "units",
        "mandatory": false,
        "defaultValue": "100%",
        "jsonPath": "styles.width"
      },
      {
        "name": "lineColor",
        "label": "Color de línea",
        "type": "color",
        "mandatory": true,
        "jsonPath": "styles.backgroundColor"
      }
    ]
  }
};
